import API from './api'

const {REACT_APP_API_URI} = process.env;



const updateProperty = (subject, keyProperty, valueProperty, collection, defaultValue) => {
    if(typeof defaultValue == "undefined") {
        defaultValue = null;
    }
    const key = subject[keyProperty];
    if(key && collection[key]) {
        subject[valueProperty] = collection[key]
    } else {
        subject[valueProperty] = defaultValue;
    }
    return subject
}

const formatOrganizations = (response) => {
    let organizations = Object.values(response.data.data.organizations);
    const users = response.data.data.users;
    const images = response.data.data.images;
    const locations = Object.values(response.data.data.locations)
  
    return organizations.map((organization) => {
        organization = updateProperty(organization, "created_by", "created_by", users);
        organization = updateProperty(organization, "updated_by", "updated_by", users);
        organization = updateProperty(organization, "deleted_by", "deleted_by", users);
        
        organization = updateProperty(organization, "profile_image_id", "profile_image", images);
        organization = updateProperty(organization, "card_image_id", "card_image", images);
        let location = locations.find((item) => item.id === organization.location_id)
        organization.city = location && location.city ? location.city : '';
        organization.state = location && location.state ? location.state : '';
        organization.country = location &&  location.country ? location.country : '';
        return organization;
    });
}


const formatOrganization = (response) => {
    let organization = response.data.data.organization;
    const users = response.data.data.users;
    const images = response.data.data.images;

    organization = updateProperty(organization, "created_by", "created_by", users);
    organization = updateProperty(organization, "updated_by", "updated_by", users);
    organization = updateProperty(organization, "deleted_by", "deleted_by", users);
    organization = updateProperty(organization, "card_image_id", "card_image", images);
    organization = updateProperty(organization, "profile_image_id", "profile_image", images);
    return organization
}

class OrganizationApi {
    constructor(token) {
        this.api = new API(token);
        this.baseUrl = `${REACT_APP_API_URI}/admin/organization`
    }

    all(status,corkboard,pageNumber) {
        try {
            const page = pageNumber || 1;
            return this.api.get(`${this.baseUrl}?status=${status}&corkboard=${corkboard}&page_num=${page}`)
            .then((response) => {
                return {
                    organizations: formatOrganizations(response),
                    total_pages: response.data.data.total_pages,
                }
            });
        }catch(error) {
            console.error(error);
            return []
        }
    }


    search(search,status,corkboard,pageNumber) {
        try {
            const page = pageNumber || 1;
            return this.api.get(`${this.baseUrl}?name=${search}&status=${status}&corkboard=${corkboard}&page_num=${page}`)
            .then((response) => {
                return {
                    organizations: formatOrganizations(response),
                    total_pages: response.data.data.total_pages,
                }
            });
        }catch(error) {
            console.error(error);
            return []
        }
    }

    getById(id) {
        try {
            return this.api.get(`${this.baseUrl}/${id}`)
            .then((response) => {
                return formatOrganization(response);
            });
        } catch(error) {
            console.error(`Error fetching organization. id=${id}, error=${error}`);
            return {}
        }
    }

    update(id, body) {
        try{
            return this.api.patch(`${this.baseUrl}/${id}`, body, "multipart/form-data")
            .then((response) => {
                return formatOrganization(response);
            });
        }catch(error) {
            console.error(`Error updating organization. id=${id}, error=${error}`);
            return {}
        }
    }

    create(body) {
        try{
            return this.api.post(this.baseUrl, body, "multipart/form-data")
            .then((response) => {
                return formatOrganization(response);
            });
        }catch(error) {
            console.error(`Error creating organization. error=${error}`);
            return{}
        }
    }

    delete(id) {
        try{
            return this.api.delete(`${this.baseUrl}/${id}`)
            .then((response) => {
                return response.data.data;
            });
        }catch(error) {
            console.error(`Error deleting organization. error=${error}`);
            return {}
        }
    }

    searchByCity(param, status, corkboard, pageNumber) {
        try {
            const page = pageNumber || 1;
            return this.api.get(`${this.baseUrl}?city=${param}&status=${status}&corkboard=${corkboard}&page_num=${page}`)
            .then((response) => {
                return  {
                    organizations: formatOrganizations(response),
                    total_pages: response.data.data.total_pages
                }
            });
        }catch(error) {
            console.error(error);
            return []
        }
    }    

    filterByLetter(status,value,corkboard, pageNumber){
        try {
            let letter = value.toLowerCase()
            const page = pageNumber || 1;
            return this.api.get(`${this.baseUrl}?status=${status}&corkboard=${corkboard}&name_start=${letter}&page_num=${page}`)
                .then((response) => {
                    return {
                        organizations: formatOrganizations(response),
                        total_pages: response.data.data.total_pages
                    }
                });
        } catch (error) {
            console.error(error);
            return []
        }
    }

    getListByLetter(status,value,corkboard){
        try {
            let letter = value.toLowerCase()
            return this.api.get(`${this.baseUrl}?status=${status}&corkboard=${corkboard}&name_start=${letter}&max_organizations=${10}`)
                .then((response) => {
                    return {
                        organizations: formatOrganizations(response),
                        total_pages: response.data.data.total_pages
                    }
                });
        } catch (error) {
            console.error(error);
            return []
        }
    }

    searchByNetwork(tenantId, status, corkboard, pageNumber) {
        try {
            const page = pageNumber || 1;
            return this.api.get(`${this.baseUrl}?tenant_id=${tenantId}&status=${status}&corkboard=${corkboard}&page_num=${page}`)
                .then((response) => {
                    return {
                        organizations: formatOrganizations(response),
                        total_pages: response.data.data.total_pages,
                    }
                });
        }catch(error) {
            console.error(error);
            return {
                organizations: [],
                total_pages: 0,
            }
        }
    }

}

export default OrganizationApi;